import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $HouseOrBlock = tag => ({tag});
const House = /* #__PURE__ */ $HouseOrBlock("House");
const Block = /* #__PURE__ */ $HouseOrBlock("Block");
const AddressExtra = x => x;
const DeliveryAddress = x => x;
const LocatedDeliveryAddress = x => x;
const newtypeLocatedDeliveryAddress = {Coercible0: () => {}};
const newtypeDeliveryAddress = {Coercible0: () => {}};
const newtypeAddressExtra = {Coercible0: () => {}};
const isPostCodeRequired = accountId => country => Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v => v1 => v || v1})})(y => {
  if (country.tag === "PL") { return y.tag === "PL"; }
  if (country.tag === "GB") { return y.tag === "GB"; }
  if (country.tag === "RU") { return y.tag === "RU"; }
  if (country.tag === "RO") { return y.tag === "RO"; }
  if (country.tag === "CZ") { return y.tag === "CZ"; }
  if (country.tag === "HR") { return y.tag === "HR"; }
  if (country.tag === "SK") { return y.tag === "SK"; }
  if (country.tag === "DE") { return y.tag === "DE"; }
  if (country.tag === "NL") { return y.tag === "NL"; }
  if (country.tag === "ES") { return y.tag === "ES"; }
  if (country.tag === "BR") { return y.tag === "BR"; }
  if (country.tag === "IT") { return y.tag === "IT"; }
  return false;
})([Restaumatic$dCountries.GB, Restaumatic$dCountries.DE]) || accountId === 31741;
const genericHouseOrBlock = {
  to: x => {
    if (x.tag === "Inl") { return House; }
    if (x.tag === "Inr") { return Block; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "House") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Block") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showHouseOrBlock = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "House"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Block"});
    return x => {
      if (x.tag === "House") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "Block") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const showAddressExtra = {
  show: record => {
    const v = Data$dShow.cons(Data$dShow.intercalate(": ")(["additionalInfo", Data$dShow.showStringImpl(record.additionalInfo)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "aptNumber",
      Data$dShow.showStringImpl(record.aptNumber)
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["block", Data$dShow.showStringImpl(record.block)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "floor",
      Data$dShow.showStringImpl(record.floor)
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["houseOrBlock", showHouseOrBlock.show(record.houseOrBlock)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "interphone",
      Data$dShow.showStringImpl(record.interphone)
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["sector", Data$dShow.showStringImpl(record.sector)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "staircase",
      Data$dShow.showStringImpl(record.staircase)
    ]))([]))))))));
    if (v.length === 0) { return "{}"; }
    return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
  }
};
const showDeliveryAddress = {
  show: record => {
    const v = Data$dShow.cons(Data$dShow.intercalate(": ")(["aptNumber", Data$dShow.showStringImpl(record.aptNumber)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "city",
      Data$dShow.showStringImpl(record.city)
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["country", Restaumatic$dCountries.showCountry.show(record.country)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "extra",
      (() => {
        if (record.extra.tag === "Just") { return "(Just " + showAddressExtra.show(record.extra._1) + ")"; }
        if (record.extra.tag === "Nothing") { return "Nothing"; }
        $runtime.fail();
      })()
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["floor", Data$dShow.showStringImpl(record.floor)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "formattedAddress",
      (() => {
        if (record.formattedAddress.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(record.formattedAddress._1) + ")"; }
        if (record.formattedAddress.tag === "Nothing") { return "Nothing"; }
        $runtime.fail();
      })()
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["postCode", Data$dShow.showStringImpl(record.postCode)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "street",
      Data$dShow.showStringImpl(record.street)
    ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["streetNumber", Data$dShow.showStringImpl(record.streetNumber)]))([])))))))));
    if (v.length === 0) { return "{}"; }
    return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
  }
};
const showLocatedDeliveryAddress = {
  show: record => {
    const v = Data$dShow.cons(Data$dShow.intercalate(": ")(["address", showDeliveryAddress.show(record.address)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
      "location",
      (() => {
        const v = Data$dShow.cons(Data$dShow.intercalate(": ")(["latitude", Data$dShow.showNumberImpl(record.location.latitude)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
          "longitude",
          Data$dShow.showNumberImpl(record.location.longitude)
        ]))([]));
        if (v.length === 0) { return "{}"; }
        return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
      })()
    ]))([]));
    if (v.length === 0) { return "{}"; }
    return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v), "}"]);
  }
};
const genericAddressExtra = {to: x => x, from: x => x};
const eqHouseOrBlock = {
  eq: x => y => {
    if (x.tag === "House") {
      if (y.tag === "House") { return true; }
      if (y.tag === "Block") { return false; }
      $runtime.fail();
    }
    if (x.tag === "Block") {
      if (y.tag === "House") { return false; }
      if (y.tag === "Block") { return true; }
      $runtime.fail();
    }
    if (y.tag === "House") { $runtime.fail(); }
    if (y.tag === "Block") { $runtime.fail(); }
    $runtime.fail();
  }
};
const eqAddressExtra = {
  eq: ra => rb => ra.additionalInfo === rb.additionalInfo && ra.aptNumber === rb.aptNumber && ra.block === rb.block && ra.floor === rb.floor && (() => {
    if (ra.houseOrBlock.tag === "House") {
      if (rb.houseOrBlock.tag === "House") { return true; }
      if (rb.houseOrBlock.tag === "Block") { return false; }
      $runtime.fail();
    }
    if (ra.houseOrBlock.tag === "Block") {
      if (rb.houseOrBlock.tag === "House") { return false; }
      if (rb.houseOrBlock.tag === "Block") { return true; }
      $runtime.fail();
    }
    if (rb.houseOrBlock.tag === "House") { $runtime.fail(); }
    if (rb.houseOrBlock.tag === "Block") { $runtime.fail(); }
    $runtime.fail();
  })() && ra.interphone === rb.interphone && ra.sector === rb.sector && ra.staircase === rb.staircase
};
const eqDeliveryAddress = {
  eq: ra => rb => ra.aptNumber === rb.aptNumber && ra.city === rb.city && (() => {
    if (ra.country.tag === "PL") { return rb.country.tag === "PL"; }
    if (ra.country.tag === "GB") { return rb.country.tag === "GB"; }
    if (ra.country.tag === "RU") { return rb.country.tag === "RU"; }
    if (ra.country.tag === "RO") { return rb.country.tag === "RO"; }
    if (ra.country.tag === "CZ") { return rb.country.tag === "CZ"; }
    if (ra.country.tag === "HR") { return rb.country.tag === "HR"; }
    if (ra.country.tag === "SK") { return rb.country.tag === "SK"; }
    if (ra.country.tag === "DE") { return rb.country.tag === "DE"; }
    if (ra.country.tag === "NL") { return rb.country.tag === "NL"; }
    if (ra.country.tag === "ES") { return rb.country.tag === "ES"; }
    if (ra.country.tag === "BR") { return rb.country.tag === "BR"; }
    if (ra.country.tag === "IT") { return rb.country.tag === "IT"; }
    return false;
  })() && (() => {
    if (ra.extra.tag === "Nothing") { return rb.extra.tag === "Nothing"; }
    if (ra.extra.tag === "Just") {
      if (rb.extra.tag === "Just") { return eqAddressExtra.eq(ra.extra._1)(rb.extra._1); }
      return false;
    }
    return false;
  })() && ra.floor === rb.floor && (() => {
    if (ra.formattedAddress.tag === "Nothing") { return rb.formattedAddress.tag === "Nothing"; }
    if (ra.formattedAddress.tag === "Just") {
      if (rb.formattedAddress.tag === "Just") { return ra.formattedAddress._1 === rb.formattedAddress._1; }
      return false;
    }
    return false;
  })() && ra.postCode === rb.postCode && ra.street === rb.street && ra.streetNumber === rb.streetNumber
};
const eqLocatedDeliveryAddress = {
  eq: ra => rb => eqDeliveryAddress.eq(ra.address)(rb.address) && ra.location.latitude === rb.location.latitude && ra.location.longitude === rb.location.longitude
};
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeForeignHouseOrBlock = {
  encode: x => {
    if (x.tag === "House") { return "House"; }
    if (x.tag === "Block") { return "Block"; }
    $runtime.fail();
  }
};
const encodeForeignAddressExtra = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AddressExtra"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "staircase"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "sector"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "interphone"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "houseOrBlock"})({encodeWithOptions: v => encodeForeignHouseOrBlock.encode}))({
        reflectSymbol: () => "floor"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "block"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "aptNumber"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "additionalInfo"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const emptyAddressExtra = {sector: "", houseOrBlock: House, block: "", staircase: "", floor: "", aptNumber: "", interphone: "", additionalInfo: ""};
const displayHouseOrBlock = v => {
  if (v.tag === "House") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.house), {});
  }
  if (v.tag === "Block") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.block), {});
  }
  $runtime.fail();
};
const defaultFormatBuildingAddress = v => v.street + " " + v.streetNumber + ", " + Data$dString$dCommon.joinWith(" ")([v.postCode, v.city]);
const formatAddressForDisplay = defaultFormatBuildingAddress;
const formatRomanianAddress = address => {
  const extra = (() => {
    if (address.extra.tag === "Nothing") { return emptyAddressExtra; }
    if (address.extra.tag === "Just") { return address.extra._1; }
    $runtime.fail();
  })();
  return Data$dString$dCommon.joinWith(", ")(Data$dSemigroup.concatArray([defaultFormatBuildingAddress(address)])(Data$dSemigroup.concatArray((() => {
    const $0 = extra.sector !== "";
    const $1 = ["Sec. " + extra.sector];
    if (!$0) { return []; }
    if ($0) { return $1; }
    $runtime.fail();
  })())(Data$dSemigroup.concatArray((() => {
    const $0 = (() => {
      if (extra.houseOrBlock.tag === "House") { return false; }
      if (extra.houseOrBlock.tag === "Block") { return true; }
      $runtime.fail();
    })();
    const $1 = Data$dSemigroup.concatArray((() => {
      const $1 = extra.block !== "";
      const $2 = ["Bl. " + extra.block];
      if (!$1) { return []; }
      if ($1) { return $2; }
      $runtime.fail();
    })())(Data$dSemigroup.concatArray((() => {
      const $1 = extra.staircase !== "";
      const $2 = ["Sc. " + extra.staircase];
      if (!$1) { return []; }
      if ($1) { return $2; }
      $runtime.fail();
    })())(Data$dSemigroup.concatArray((() => {
      const $1 = extra.floor !== "";
      const $2 = ["Et. " + extra.floor];
      if (!$1) { return []; }
      if ($1) { return $2; }
      $runtime.fail();
    })())(Data$dSemigroup.concatArray((() => {
      const $1 = extra.aptNumber !== "";
      const $2 = ["Ap. " + extra.aptNumber];
      if (!$1) { return []; }
      if ($1) { return $2; }
      $runtime.fail();
    })())((() => {
      const $1 = extra.interphone !== "";
      const $2 = ["Intf. " + extra.interphone];
      if (!$1) { return []; }
      if ($1) { return $2; }
      $runtime.fail();
    })()))));
    if (!$0) { return []; }
    if ($0) { return $1; }
    $runtime.fail();
  })())((() => {
    const $0 = extra.additionalInfo !== "";
    const $1 = ["Reper: " + extra.additionalInfo];
    if (!$0) { return []; }
    if ($0) { return $1; }
    $runtime.fail();
  })()))));
};
const formatCountrySpecificAddress = country => address => {
  if (country.tag === "RO") { return Data$dMaybe.$Maybe("Just", formatRomanianAddress(address)); }
  return Data$dMaybe.Nothing;
};
const decodeForeignHouseOrBlock = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericHouseOrBlock)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "House"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Block"})))
};
const decodeForeignAddressExtra = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericAddressExtra)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "AddressExtra"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "staircase"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "sector"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "interphone"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "houseOrBlock"})({
    decodeWithOptions: v => decodeForeignHouseOrBlock.decode
  })())({reflectSymbol: () => "floor"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "block"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "aptNumber"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "additionalInfo"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  $HouseOrBlock,
  AddressExtra,
  Block,
  DeliveryAddress,
  House,
  LocatedDeliveryAddress,
  decodeForeignAddressExtra,
  decodeForeignHouseOrBlock,
  defaultFormatBuildingAddress,
  displayHouseOrBlock,
  emptyAddressExtra,
  encodeForeignAddressExtra,
  encodeForeignHouseOrBlock,
  encodingOpts,
  eqAddressExtra,
  eqDeliveryAddress,
  eqHouseOrBlock,
  eqLocatedDeliveryAddress,
  formatAddressForDisplay,
  formatCountrySpecificAddress,
  formatRomanianAddress,
  genericAddressExtra,
  genericHouseOrBlock,
  isPostCodeRequired,
  newtypeAddressExtra,
  newtypeDeliveryAddress,
  newtypeLocatedDeliveryAddress,
  showAddressExtra,
  showDeliveryAddress,
  showHouseOrBlock,
  showLocatedDeliveryAddress
};
